export default function getSubscriptionIntervalWithSlash(
  interval,
  intervalCount,
  page,
) {
  const separator = '/';
  let intervalText = interval;

  if (page) {
    switch (interval) {
      case 'day':
        if (page.dayText) {
          intervalText = page.dayText;
        }
        break;
      case 'week':
        if (page.weekText) {
          intervalText = page.weekText;
        }
        break;
      case 'month':
        if (page.monthText) {
          intervalText = page.monthText;
        }
        break;
      case 'year':
        if (page.yearText) {
          intervalText = page.yearText;
        }
        break;
      default:
        break;
    }
  }

  // add 's' to pluralize if intervalText hasn't been edited
  if (intervalText === interval && intervalCount && intervalCount > 1) {
    intervalText = `${intervalText}s`;
  }

  // combine interval text with intervalCountText (or 'Every')
  if (intervalCount && intervalCount > 1) {
    intervalText = [
      (page && page.intervalCountText) || 'every',
      intervalCount,
      intervalText,
    ].join(' ');
  }

  if (intervalCount === 1) {
    intervalText = [separator, intervalText].join(' ');
  }

  return intervalText;
}
